module.exports = __webpack_public_path__ + "img/anyCast.7e8901e.svg";